const { debounce: baoDebounce } = window.BAO.Utils

class Hotspots extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.classes = {
      active: 'prd-Hotspot-active',
    }
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.els?.form?.elements.forEach((form) => {
      form.addEventListener('submit', () => {
        this.hideAllPopups()
      })
    })

    this.els?.submit?.elements.forEach((submit) => {
      submit.addEventListener('click', () => {
        this.hideAllPopups()
      })
    })

    this.els?.toggle?.elements.forEach((toggle) => {
      const parentHotspot = toggle.closest(
        '[data-product-hotspots-el="hotspot"]',
      )

      if (!parentHotspot) return

      toggle.addEventListener('click', () => {
        this.hideOtherPopups(parentHotspot)
        parentHotspot.classList.toggle(this.classes.active)

        if (parentHotspot.classList.contains(this.classes.active)) {
          Shopify.analytics.publish('hotspots:click', {
            handle: parentHotspot.dataset.productHandle,
          })
        }
      })
    })

    this.els?.close?.elements.forEach((close) => {
      const parentHotspot = close.closest(
        '[data-product-hotspots-el="hotspot"]',
      )

      if (!parentHotspot) return

      close.addEventListener('click', () => {
        parentHotspot.classList.remove(this.classes.active)
      })
    })
  }

  hideAllPopups () {
    this.els?.hotspot?.elements.forEach((hotspot) => {
      hotspot.classList.remove(this.classes.active)
    })
  }

  hideOtherPopups (target) {
    this.els?.hotspot?.elements.forEach((hotspot) => {
      if (hotspot !== target) hotspot.classList.remove(this.classes.active)
    })
  }
}

if (!customElements.get('product-hotspots')) {
  customElements.define('product-hotspots', Hotspots)
}
